export const PartFinderPageObjectModel = {
  FindPartButton: 'find-part-button',
  PartNumberInput: 'part-number-input',
  DescriptionInput: 'description-input',
  ErrorAlert: 'error-alert',
  LoadingSpinner: 'loading-spinner',
  PartNumberSuggestion: 'part-number-suggestion',
};
